import { type RouteObject } from 'react-router'
import { lazy } from 'react'
import type { RequestMagicLinkViewModel } from './RequestMagicLinkView/RequestMagicLinkViewModel'

export interface CreateMagicLinkRoutesOptions {
  requestMagicLinkVm: RequestMagicLinkViewModel
}

/**
 * Creates routes for request magic link feature.
 */
export function createRoutes(
  options: CreateMagicLinkRoutesOptions,
): RouteObject[] {
  return [
    {
      path: 'request-magic-link',
      loader: ({ request }) => {
        const searchParams = new URL(request.url).searchParams
        const email = searchParams.get('email')

        if (email) {
          options.requestMagicLinkVm.setEmail(email)
        }
        return null
      },
      Component: lazy(
        () => import('@/features/iam/magic-link/RequestMagicLinkView/'),
      ),
    },
  ]
}
